"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDataGrid_unstable", {
    enumerable: true,
    get: ()=>renderDataGrid_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _renderTable = require("../Table/renderTable");
const _dataGridContext = require("../../contexts/dataGridContext");
const renderDataGrid_unstable = (state, contextValues)=>{
    return /*#__PURE__*/ _react.createElement(_dataGridContext.DataGridContextProvider, {
        value: contextValues.dataGrid
    }, (0, _renderTable.renderTable_unstable)(state, contextValues));
}; //# sourceMappingURL=renderDataGrid.js.map

//# sourceMappingURL=renderDataGrid.js.map